import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/logs')({
  beforeLoad: () => getTitleContextSlice('Logs'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
